import { IMenuOptions } from './Menu.interface';

export const MenuOptions: IMenuOptions[] = [
  {
    icon: 'search',
    label: 'Procurar'
  },
  {
    icon: 'home',
    label: 'Início'
  },
  {
    icon: 'media-podcast',
    label: 'Transmissões'
  },
  {
    icon: 'carousel',
    label: 'Categorias'
  },
  {
    icon: 'profile',
    label: 'Perfil'
  }
];
